<template>
    <div id="DrugsProtocolsContainer">
        <div class="row">
            <div class="col-12">
                <h4 class="page-title text-truncate">{{$t('DrugSetupProtocol.Title')}}</h4>
            </div>
            <div class="alert alert-fill-warning d-flex align-items-center m-3" role="alert" v-if="isReadOnly">
                <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
                <div class="flex-grow-1">
                    <span>{{ $t('Shared.ReadOnlyPermission') }}</span>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12 col-md-3" v-if="hasPermissionAdd()">                      
                <MdButton
                    v-bind:Label="$t('DrugSetupProtocol.Add')" 
                    v-bind:ClassProp="isReadOnly ? 'btn btn-primary my-3 btn-block' : 'btn btn-primary my-3 btn-block btn-login'"
                    v-bind:IconClass="'ti-plus pr-1'"
                    v-on:click="addDrugSetupProtocol"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:Name="'btn_add_AddDrugSetupProtocol'">
                </MdButton>
            </div>

            <div class="col-sm-12" :class="{'col-md': hasPermissionAdd(), 'col-md-12': !hasPermissionAdd()}">
                <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                    <div class="input-group" dir="ltr">
                        <input 
                            type="text" 
                            class="form-control"
                            :dir="dirInput"
                            v-model="parameter.SearchCriteria"
                            @keyup.enter="searchListing">
                        <div class="input-group-append">
                            <div class="input-group-append">
                                <MdButton
                                    v-bind:Name="'btnsearchinput'"
                                    v-bind:VariantProp="'btn btn-sm search-attached'"
                                    v-bind:IconClass="'mdi mdi-magnify'"
                                    v-on:click="searchListing">
                                </MdButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 mt-2">
                <MdTitle v-bind:Text="$t('Shared.SearchElements')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <MdTable 
                    v-bind:fields="fields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"                
                    v-bind:pageOptions="pageOptions"
                    :editIconEvent="editDrugSetupProtocol"
                    v-bind:VisibleEditIcon="hasPermissionEdit()"
                    :deleteIconEvent="removeDrugSetupProtocol"
                    v-bind:VisibleDeleteIcon="hasPermissionDelete()"
                    :onRowSelected="onRowSelected"
                    :onFiltered="onFiltered"
                    :pageChanged="pageChanged"
                    :perPageFunction="PerPageFunction"
                >
                </MdTable>
            </div>
        </div>
        
        <div class="space-actions"></div>
        <div class="page-actions">
        </div>
    </div>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js';
import DBFunctions from '@/common/DBFunctions.js';
import Permission from '@/common/Permission'
import MedicationService from '@/services/medication.service.js'

export default {
    name: 'DrugsProtocolSetupList',
    mixins: [ShowMessage, DBFunctions, Permission],

    data() {
        return {
            OptionsRightMenu:{
                visible:false,
                ItemsList:[],
                btnvisible:false,
                itemdisabled: false,
                PatientCode:'',
                Mode:this.edit_mode,
                favButtonAtion:false          
            },
            isReadOnly:false,
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
            Header:{},
            parameter:{
                SearchCriteria:'',
                PageNumber: 1,
                PageSize: 0,
            },
            ShowMessageIsEmpty:false,
            pageOptions: [5, 10, 15],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            items: [],         
            fields: [
                { key: 'code', sortable: true, label: this.$t('Shared.Code'), class:'hidden'},
                { key: 'description', sortable: true, label: this.$t('Shared.Description')},
                { key: 'diagDescription', sortable: true, label: this.$t('Shared.DiagnosisDescription')},
                { key: 'diagCode', sortable: true, label: this.$t('Shared.DiagnosisCode')},
                { key: 'remarks', sortable: true, label: this.$tc('Shared.Note', 2)},
            ]
        }
    },

    methods: {
        addDrugSetupProtocol() {
            this.emitDataforFavorites(); 
            this.$router.push({ name: "DrugsProtocolSetup-Add"});
        },

        editDrugSetupProtocol(row) {
            this.$router.push({ name: "DrugsProtocolSetup-Detail", params: { id: row.code } }).catch(()=>{});
        },

        removeDrugSetupProtocol(row) {
            const Id = row.code
            this.$bvModal.msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
					title: this.$tc('Shared.DelRecord'),
					okTitle: this.$t('Shared.TitleDelete'),
					cancelTitle: this.$t('Shared.BtnCancel'),
					footerClass: 'p-2',
					titleClass: 'modal-title modal-type-warning',
                    id:'modal_delete_drug'
				})
            .then(value => {
                if(value){
                    MedicationService.deleteProtocolSetup(Id)
                        .then(() => {
                            const index = this.items.findIndex(item => item.code === Id) // find the post index 
                            if (~index) {// if the post exists in array 
                                this.items.splice(index, 1) //delete the post and refresh view
                                this.getListing(); //refresh listing
                            }
                        })
                        .catch((error) => {
                            this.showResponseErrorMessage(error);
                        });
                }
            })
        },

        searchListing() {
            this.currentPage = 1;
            this.getListing();
        },

        getListing() {
            this.parameter.PageNumber = this.currentPage;
            this.parameter.PageSize = this.perPage;
            MedicationService
                .getStandingOrders(this.parameter)
                .then((response) => {
                    if (response.data) {                    
                        this.items = response.data;
                        let headerString = response.headers["x-pagination"];
                        this.Header = JSON.parse(headerString);
                        this.totalRows = this.Header.TotalCount;
                    }

                    this.ShowMessageIsEmpty = this.items.length === 0 ? true : false;
                })
                .catch(error => {                
                    this.showResponseErrorMessage(error);
                });
        },

        pageChanged(page){
            this.currentPage = page;    
            this.getListing();   
        },

        PerPageFunction(perpage){
            this.perPage = perpage;  
            this.currentPage = 1;
            this.getListing();  
        },

        onRowSelected(){

        },
        onFiltered(){

        },
    },

    async mounted(){
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch(layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
            break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }

        await this.getListing();
    }
}
</script>